import * as C from "../../config/constants.js";
import { isBodyShrinking, queueShrinkMotion, getShrinkDrawRadiiForMeta } from "./shrink-motion.js";

export function getMinimizePhysicsFloorTier() {
  return C.MINIMIZE_PHYSICS_SIZE_TIER != null ? C.MINIMIZE_PHYSICS_SIZE_TIER : 0;
}

export function getMinimizePhysicsTierStep() {
  var step = C.MINIMIZE_PHYSICS_TIER_STEP != null ? Number(C.MINIMIZE_PHYSICS_TIER_STEP) : 4;
  return isFinite(step) && step > 0 ? Math.floor(step) : 4;
}

/** Effective Matter.js radius tier (defaults to identity tier). */
export function getMetaPhysicsSizeTier(meta) {
  if (!meta) return 0;
  if (meta.physicsSizeTier != null) return meta.physicsSizeTier;
  if (meta.minimized) return getMinimizePhysicsFloorTier();
  return meta.tier != null ? meta.tier : 0;
}

export function getNextMinimizePhysicsTier(meta) {
  var current = getMetaPhysicsSizeTier(meta);
  var floor = getMinimizePhysicsFloorTier();
  return Math.max(floor, current - getMinimizePhysicsTierStep());
}

export function isMinimizableMeta(meta) {
  if (!meta || !meta.body) return false;
  if (meta._shrinkAnimating) return false;
  var tier = meta.tier != null ? meta.tier : 0;
  if (tier <= getMinimizePhysicsFloorTier()) return false;
  return getMetaPhysicsSizeTier(meta) > getMinimizePhysicsFloorTier();
}

/**
 * Ellipse hit-test in flask-panel space (same coords as Matter body positions).
 */
export function pickBodyAtPanelPoint(system, panelX, panelY) {
  if (!system || !system.bodies || system.bodies.length === 0) return null;
  var best = null;
  var bestDist = Infinity;
  for (var i = 0; i < system.bodies.length; i++) {
    var meta = system.bodies[i];
    var body = meta.body;
    if (!body || !body.position) continue;
    var shrinkRadii = getShrinkDrawRadiiForMeta(system, meta);
    var rx = shrinkRadii ? shrinkRadii.radiusX : (meta.radiusX != null ? meta.radiusX : 10);
    var ry = shrinkRadii ? shrinkRadii.radiusY : (meta.radiusY != null ? meta.radiusY : rx);
    if (!(rx > 0) || !(ry > 0)) continue;
    var dx = (panelX - body.position.x) / rx;
    var dy = (panelY - body.position.y) / ry;
    var dist = dx * dx + dy * dy;
    if (dist <= 1.05 && dist < bestDist) {
      bestDist = dist;
      best = meta;
    }
  }
  return best;
}

/**
 * Shrink physics by MINIMIZE_PHYSICS_TIER_STEP while keeping evolution tier (sprite + merge rules).
 * Repeatable until physics size reaches MINIMIZE_PHYSICS_SIZE_TIER (cell).
 * @returns {boolean} false when already at minimum physics size, tier 0, or body missing
 */
export function minimizeBodyForSystem(system, meta) {
  if (!system || !meta || !meta.body) return false;
  if (!isMinimizableMeta(meta)) return false;
  if (isBodyShrinking(system, meta.body.id)) return false;

  system.ensureEngine();
  return queueShrinkMotion(system, meta);
}